import { RequiredCustomerWarning } from '~/purchase/components';
import { usePurchaseContext } from '~/purchase/context';

export default function QuoteCustomerProtected({
  component: Component,
}: {
  component: React.ComponentType;
}) {
  const { state } = usePurchaseContext();

  if (state.targetCustomer?.quoteSearchable) {
    return <Component />;
  }
  return <RequiredCustomerWarning />;
}
